<style lang="scss">
.AuthorizerFormChange {
  background-color: lightcyan;
}
</style>

<template>
<form
  class="AuthorizerForm AuthorizerFormChange"
  name="authorizer-reset"
  @submit.prevent="submit">

  <div class="AuthorizerForm__fieldset">
    <InputText class="input-text" type="password"
      name="change-password-current"
      v-model="valueCurrent"
      autocomplete="new-password"
      autocapitalize="off"
      autocorrect="off"
      spellcheck="false"
      placeholder="Current password"/>

    <InputText class="input-text" type="password"
      name="change-password-new"
      v-model="valueNew"
      autocomplete="new-password"
      autocapitalize="off"
      autocorrect="off"
      spellcheck="false"
      placeholder="New password"/>

    <InputText class="input-text" type="password"
      name="change-password-confirm"
      v-model="valueConfirm"
      autocomplete="new-password"
      autocapitalize="off"
      autocorrect="off"
      spellcheck="false"
      placeholder="Confirm new password"/>

  </div>

  <div class="AuthorizerForm__submit">
    <button class="button" @click.prevent="submit">
      <span>Change</span>
    </button>
  </div>

</form>
</template>

<script>
import InputText from '@/components/input-text/InputText.vue';
export default {
  name: 'AuthorizerChange',
  components: {InputText},
  data() {
    return {
      valueNew: '',
      valueConfirm: '',
      valueCurrent: '',
    };
  },
  methods: {
    async submit() {
      const {valueNew, valueCurrent} = this;
      // const {data, error} = await this.$store.dispatch('user/passwordChange', {login});
      console.log('CHANGE', valueCurrent, valueNew);
    },
  },
}
</script>
